var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77764 16.4941C3.33912 16.687 3.11987 16.7835 2.98532 16.7411C2.86868 16.7044 2.77727 16.6131 2.74041 16.4965C2.69788 16.362 2.79409 16.1426 2.98652 15.7039L8.44755 3.25277C8.62125 2.85671 8.70811 2.65869 8.82953 2.59807C8.93499 2.54543 9.05905 2.54543 9.1645 2.59807C9.28593 2.65869 9.37278 2.85671 9.54649 3.25277L15.0075 15.7039C15.1999 16.1426 15.2962 16.362 15.2536 16.4965C15.2168 16.6131 15.1254 16.7044 15.0087 16.7411C14.8742 16.7835 14.6549 16.687 14.2164 16.4941L9.23866 14.3039C9.14965 14.2647 9.10514 14.2451 9.05891 14.2374C9.01793 14.2305 8.9761 14.2305 8.93513 14.2374C8.8889 14.2451 8.84439 14.2647 8.75538 14.3039L3.77764 16.4941Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.3c50a07f38188989126a947f79fc049f.svg";
export { ForwardRef as ReactComponent };